/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.admin', [])
    .factory('adminService', AdminService)
    .name;

/*@ngInject*/
function AdminService($http, $q) {

    var service = {
        getAdminSettings: getAdminSettings,
        saveAdminSettings: saveAdminSettings,
        sendTestMail: sendTestMail,
        sendTestSms: sendTestSms
    }

    return service;

    function getAdminSettings(key) {
        var deferred = $q.defer();
        var url = '/api/admin/settings/' + key;
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveAdminSettings(settings) {
        var deferred = $q.defer();
        var url = '/api/admin/settings';
        $http.post(url, settings).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail(response) {
            deferred.reject(response.data);
        });
        return deferred.promise;
    }

    function sendTestMail(mailTo) {
        var deferred = $q.defer();
        var url = '/api/admin/settings/testMail/' + mailTo;
        $http.post(url).then(function success() {
            deferred.resolve();
        }, function fail(response) {
            deferred.reject(response.data);
        });
        return deferred.promise;
    }

    function sendTestSms(smsTo, smsBody) {
        var deferred = $q.defer();
        var url = '/api/admin/settings/testSms/' + smsTo + '/' + smsBody;
        $http.post(url).then(function success() {
            deferred.resolve();
        }, function fail(response) {
            deferred.reject(response.data);
        });
        return deferred.promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/api/admin.service.js